import {
  createErrorType,
  createFetchType,
  createLoadingType,
  createSubmitType,
  createSuccessType,
} from '../actionHelpers';

const GET_TRIGGER_ORDER_QUOTE_SCOPE = 'GET_TRIGGER_ORDER_QUOTE';
export const GET_TRIGGER_ORDER_QUOTE = createFetchType(
  GET_TRIGGER_ORDER_QUOTE_SCOPE,
);
export const GET_TRIGGER_ORDER_QUOTE_SUCCESS = createSuccessType(
  GET_TRIGGER_ORDER_QUOTE_SCOPE,
);
export const GET_TRIGGER_ORDER_QUOTE_ERROR = createErrorType(
  GET_TRIGGER_ORDER_QUOTE_SCOPE,
);
export const GET_TRIGGER_ORDER_QUOTE_LOADING = createLoadingType(
  GET_TRIGGER_ORDER_QUOTE_SCOPE,
);

const EXECUTE_TRIGGER_ORDER_QUOTE_SCOPE = 'EXECUTE_TRIGGER_ORDER_QUOTE';
export const EXECUTE_TRIGGER_ORDER_QUOTE = createSubmitType(
  EXECUTE_TRIGGER_ORDER_QUOTE_SCOPE,
);
export const EXECUTE_TRIGGER_ORDER_QUOTE_SUCCESS = createSuccessType(
  EXECUTE_TRIGGER_ORDER_QUOTE_SCOPE,
);
export const EXECUTE_TRIGGER_ORDER_QUOTE_ERROR = createErrorType(
  EXECUTE_TRIGGER_ORDER_QUOTE_SCOPE,
);
export const EXECUTE_TRIGGER_ORDER_QUOTE_LOADING = createLoadingType(
  EXECUTE_TRIGGER_ORDER_QUOTE_SCOPE,
);
